/**
 * Visionary Hills — SMS Popup Logic
 * Place in: assets/popup-sms.js
 *
 * Triggers Postscript's native popup (handles OTP opt-in, suppression, etc.)
 * Triggers: 3 seconds after load OR 40% scroll depth — whichever comes first.
 */

(function () {
  'use strict';

  const DELAY_MS   = 3000;
  const SCROLL_PCT = 0.40;
  const POPUP_MOBILE  = 497540;
  const POPUP_DESKTOP = 497541;

  function getPopupId() {
    return window.innerWidth < 768 ? POPUP_MOBILE : POPUP_DESKTOP;
  }

  function openPopup() {
    var ps = window.postscript;
    if (ps && ps.popups && typeof ps.popups.open === 'function') {
      ps.popups.open(getPopupId());
    }
    clearTriggers();
  }

  var scrollHandler, timerHandle;

  function clearTriggers() {
    clearTimeout(timerHandle);
    window.removeEventListener('scroll', scrollHandler);
  }

  scrollHandler = function () {
    var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
    if (pct >= SCROLL_PCT) openPopup();
  };

  function init() {
    // Don't trigger on the /join page — join-page.js handles it there
    if (window.location.pathname === '/pages/join') return;
    timerHandle = setTimeout(openPopup, DELAY_MS);
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
